import { atom } from 'jotai';
import { atomFamily } from 'jotai/utils';
import { AppNavigationLinkName } from './NavigationLinks';

export const shownAtomFamily = atomFamily((name: AppNavigationLinkName) =>
  atom(false),
);

export const showQueueAtom = atom<AppNavigationLinkName[]>([]);
